<template lang="html">
    <div>
        Page not found.
    </div>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// not_found.vue?18333c74